module.exports = __webpack_public_path__ + "img/multimodal_emo.59aa94bd.png";